import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#121212] group-[.toaster]:text-white group-[.toaster]:border-[#D4AF37]/30 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-white/60",
          actionButton:
            "group-[.toast]:bg-[#D4AF37] group-[.toast]:text-black",
          cancelButton:
            "group-[.toast]:bg-[#1c1c1c] group-[.toast]:text-white/60",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
